export const isMac = navigator.userAgent.toLowerCase().indexOf('mac') !== -1;
export const isWin = navigator.userAgent.toLowerCase().indexOf('win') !== -1;
